import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { getMe, updateUser } from "../services/userService";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import FormComponent from "./common/formComponent";
import PageLoading from "./common/pageLoading";
import { Paper } from "@material-ui/core";

class MyAccount extends FormComponent {
  state = {
    data: {
      _id: "",
      fullName: "",
      email: "",
      dob: "",
      phone: "",
      category: "",
      permission: "",
      address: "",
      notes: undefined,
    },
    loading: "",
    processing: false,
    errors: {},
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  schema = {
    _id: Joi.string().required(),
    fullName: Joi.string().required().label("Full Name"),
    email: Joi.string().email().required().label("Email"),
    dob: Joi.date().required().label("Date of Birth"),
    phone: Joi.string().required().label("Phone Number"),
    category: Joi.string().required().label("Category"),
    permission: Joi.string().required().label("Permission"),
    address: Joi.string().required().label("Address"),
    notes: Joi.string().max(50).optional().label("Notes"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const updatedData = this.state.data;
    try {
      await updateUser(updatedData._id, updatedData);
      toast.success("Information Updated");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    try {
      const { data } = await getMe();
      this.setState({ data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  render() {
    const { data, errors, loading, processing } = this.state;
    return (
      <Paper elevation={3}>
        <div className="card">
          <div className="card-header main-color-bg">
            <h5>Account Information</h5>
          </div>
          <div className="card-body">
            <span className="card-text">
              {loading && <PageLoading loading={loading} />}
              {!loading && (
                <Form className="mt-4" onSubmit={this.handleSubmit}>
                  <Form.Group as={Row} controlId="fullName">
                    <Form.Label column sm={2}>
                      Full Name
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control
                        name="fullName"
                        onChange={this.handleChange}
                        value={data.fullName}
                        size="sm"
                        type="text"
                        disabled={true}
                      />
                      {errors.fullName && <span className="text-danger">{errors.fullName}</span>}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="email">
                    <Form.Label column sm={2}>
                      Email
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control
                        name="email"
                        onChange={this.handleChange}
                        value={data.email}
                        size="sm"
                        type="email"
                      />
                      {errors.email && <span className="text-danger">{errors.email}</span>}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="phone">
                    <Form.Label column sm={2}>
                      Phone Number
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control name="phone" onChange={this.handleChange} value={data.phone} size="sm" type="tel" />
                      {errors.phone && <span className="text-danger">{errors.phone}</span>}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="category">
                    <Form.Label column sm={2}>
                      Category
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control plaintext readOnly defaultValue={data.category} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="address">
                    <Form.Label column sm={2}>
                      Address
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control
                        name="address"
                        onChange={this.handleChange}
                        value={data.address}
                        as="textarea"
                        rows="3"
                        disabled={true}
                      />
                      {errors.address && <span className="text-danger">{errors.address}</span>}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Col sm={{ span: 10, offset: 2 }}>
                      <Button type="submit" disabled={this.validate() || processing}>
                        {processing && (
                          <Spinner
                            as="span"
                            className="mr-2"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Update
                      </Button>
                    </Col>
                  </Form.Group>
                </Form>
              )}
            </span>
          </div>
        </div>
      </Paper>
    );
  }
}

export default MyAccount;
